import "./CreatingIdentity.scss";
import React from "react";
import { IonContent, IonIcon, IonProgressBar, IonText } from "@ionic/react";
import moment from "moment";

import logoAbaxxIcon from "../../assets/svg/logoAbaxx.svg";
import p from "../../../package.json";

interface Props {
  isShow?: boolean;
  inProgressTitle?: string;
  finishTitle?: string;
  isAccountCreated: boolean;
  progressValue?: number;
  loadingText?: string;
}

const CreatingIdentity: React.FC<Props> = ({
  isShow = true,
  inProgressTitle = "Creating Identity...",
  finishTitle = "Identity Created!",
  progressValue,
  loadingText,
  isAccountCreated,
}) => {
  return (
    <IonContent className="creating-identity" hidden={!isShow}>
      <div className="creating-identity-container">
        <div className="creating-identity-content">
          <IonIcon icon={logoAbaxxIcon} className="icon" />
          <IonText className="title">
            {isAccountCreated ? finishTitle : inProgressTitle}
          </IonText>

          <div className="progressbar-container">
            <IonProgressBar value={progressValue} mode="ios" />
          </div>

          <p className="loading-text">
            {isAccountCreated ? "Done!" : loadingText}
          </p>

          <p className="footer-text">
            © {moment().format("YYYY")} Abaxx Technologies | ver {p.version}
          </p>
        </div>
      </div>
    </IonContent>
  );
};

export default CreatingIdentity;
